import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-demo-success',
  templateUrl: './demo-success.component.html',
  styleUrl: './demo-success.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DemoSuccessComponent {
  public calendlyBaseUrl: string = "https://calendly.com/victoria-careaudits/30min";
  public calendlyUrl: string = this.calendlyBaseUrl;

  constructor(private route: ActivatedRoute){
  }

  ngOnInit(){
    this.route.queryParams.subscribe((params:Params) => {
      const name = typeof params['name'] === 'string' ? params['name'] : '';
      const email = typeof params['email'] === 'string' ? params['email'] : '';
      this.calendlyUrl = this.buildCalendlyUrl(name, email);
    });
  }

  private buildCalendlyUrl(name: string, email: string): string {
    const trimmedName = name.trim();
    const trimmedEmail = email.trim();
    const params: string[] = [];
    if (trimmedName){
      params.push(`name=${encodeURIComponent(trimmedName)}`);
    }
    if (trimmedEmail){
      params.push(`email=${encodeURIComponent(trimmedEmail)}`);
    }
    if (params.length === 0){
      return this.calendlyBaseUrl;
    }
    return `${this.calendlyBaseUrl}?${params.join('&')}`;
  }
}
